import { format } from 'date-fns'

const displayDateFormatter = new Intl.DateTimeFormat('de-CH', {
  timeZone: 'Europe/Zurich',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
})

export function formatDateString(dateStr: string) {
  const date = new Date(dateStr)
  return format(date, 'dd.MM.yyyy')
}

export function getFormattedInputDate(date: Date) {
  let parseDate = date
  if (isNaN(date.getFullYear())) {
    parseDate = new Date()
  }
  const year = parseDate.getFullYear()

  let month = (1 + parseDate.getMonth()).toString()
  month = month.length > 1 ? month : '0' + month

  let day = parseDate.getDate().toString()
  day = day.length > 1 ? day : '0' + day

  return year + '-' + month + '-' + day
}

export function getFormattedDisplayDate(date?: Date | null) {
  return date ? displayDateFormatter.format(date) : ''
}

export function getFormattedDisplayDateAndTime(date?: Date | null) {
  if (!date) {
    return ''
  }
  const time = date.toLocaleTimeString('de-DE', {
    timeZone: 'Europe/Zurich',
    hour: '2-digit',
    minute: '2-digit',
  })

  return getFormattedDisplayDate(date) + ', ' + time + ' Uhr'
}
